import { Route, Routes, Navigate, useParams } from "react-router-dom";
import About from "./Pages/about/About";
import Services from "./Pages/Services/Services";
import Pecb from "./Pages/pecb/Pecb";
import Team from "./Pages/team/Team";
import Trainings from "./Pages/trainings/Trainings";
import Blog from "./Pages/blog/Blog";
import Contact from "./Pages/contact/Contact";
import Jobs from "./Pages/jobs/Jobs";
import Certification from "./Pages/Services/Certification/Certification";
import Auditing from "./Pages/Services/Auditing/Audidting";
import SkillBuilding from "./Pages/Services/Skill Building/SkillBuilding";
import WhatsAppLogo from "./WhatsappLogo/WhatsAppLogo";
import MainHome from "./Pages/Home/MainHome";
import { useEffect, useState } from "react";
import { BsChevronUp } from "react-icons/bs";
import ServicePage2 from "./Pages/IndustrialCoverage/ServiceInnerPage";
import Login from "./ServerSide/Login";
import Toolkits from "./Pages/toolkits/Toolkits";
import PaymentForm from "./Pages/toolkits/PaymentForm";
import PageNotFound from "./Pages/PageNotFound";
import Cookies from "./components/Cookies";
import Tracking from "./Pages/tracking/Tracking";
import AdminBlogUpdate from "./ServerSide/Blogs/AdminBlogUpdate";
import { useCookies } from "react-cookie";
import NewBlogPage from "./Pages/blog/NewBlogPage";
import Dashboard from "./ServerSide/Dashoard/Dashboard";
import UpdateTeam from "./ServerSide/Team/UpdateTeam";
import UpdateClient from "./ServerSide/Client/UpdateClient";
import Clientele from "./Pages/Clientele/Clientele";
import TermsAndConditions from "./Pages/TermsConditition/TermsAndConditions";
import UpdatePosting from "./ServerSide/JobsPosting/UpdatePosting";
import Success from "./Pages/responsePage/Success";
import Cancel from "./Pages/responsePage/Cancel";
import Sustainability from "./Pages/Sustainability/Sustainability";
import TrainingDetails from "./Pages/trainings/TrainingDetails";
import RegisterForm from "./Pages/trainings/RegisterForm";
import Environment from "./Pages/Sustainability/innerpage/Environment";
import SocialGovernance from "./Pages/Sustainability/innerpage/SocialGovernance";
import SustainabilityManagment from "./Pages/Sustainability/innerpage/MaximizeSustainability/MaximizeSustainability";
import EnvironmentPolicy from "./Pages/Sustainability/innerpage/Environment/EnvironmentPolicy";
import AOS from "aos";
import "aos/dist/aos.css";
import EnvironmentManagment from "./Pages/Sustainability/innerpage/Environment/EnvironmentManagment";
import EnvironmentalBalance from "./Pages/Sustainability/innerpage/Environment/EnvironmentalBalance";
import Biodiversity from "./Pages/Sustainability/innerpage/Environment/Biodiversity";
import ClimateChange from "./Pages/Sustainability/innerpage/Environment/ClimateChange";
import ResourceCircularity from "./Pages/Sustainability/innerpage/Environment/ResourceCircularity";
import HumanLabouredRight from "./Pages/Sustainability/innerpage/SocialGovernance/HumanLabouredRight";
import Diversity from "./Pages/Sustainability/innerpage/SocialGovernance/Diversity";
import Relationshipwithsociety from "./Pages/Sustainability/innerpage/SocialGovernance/Relationshipwithsociety";
import Fulfillmentwork from "./Pages/Sustainability/innerpage/SocialGovernance/Fulfillmentwok";
import OccupationalHealth from "./Pages/Sustainability/innerpage/SocialGovernance/OccupationalHealth";
import SupplyChain from "./Pages/Sustainability/innerpage/SocialGovernance/SupplyChain";
import RiskManagement from "./Pages/Sustainability/innerpage/SocialGovernance/RiskManagement";
import Compilance from "./Pages/Sustainability/innerpage/SocialGovernance/Compilance";
import IntelectualProperty from "./Pages/Sustainability/innerpage/SocialGovernance/IntellectualProperty";
import CorporateGovernance from "./Pages/Sustainability/innerpage/SocialGovernance/CorporateGovernance";
import QualityAssurance from "./Pages/Sustainability/innerpage/SocialGovernance/QualityAssuance";
import ItTechnology from "./Pages/Sustainability/innerpage/ItTechnology";
import EnergyManagement from "./Pages/Sustainability/innerpage/It Technology/EnergyManagment";
import CyberSecurity from "./Pages/Sustainability/innerpage/It Technology/CyberSecurity";
import SustainableIt from "./Pages/Sustainability/innerpage/It Technology/SustainableIt";
import EthicalSourcing from "./Pages/Sustainability/innerpage/It Technology/EthicalSourcing";
import SustainabilityManagement from "./Pages/Sustainability/innerpage/SustainabilityManagement";
import FSCCertification from "./Pages/fsc/FSCCertification";
import CompanyIntroduction from "./Pages/about/CompanyIntroduction";
import Mission from "./Pages/about/Mission";
import Vision from "./Pages/about/Vision";
import DiversifiedClientele from "./Pages/about/DiversifiedClientele";
import ISOCertifications from "./Pages/Services/ISOCertifications";
import FSCCOCCertification from "./Pages/Services/FSCCOCCertification";
import FoodSafetyCertification from "./Pages/Services/FoodSafetyCertification";
import HalalCertification from "./Pages/Services/HalalCertification";
import ITCyberSecurity from "./Pages/Services/ITCyberSecurity";
import SustainabilityESG from "./Pages/Services/SustainabilityESG";
import AuditsDocumentation from "./Pages/Services/AuditsDocumentation";
import AccreditationReadiness from "./Pages/Services/AccreditationReadiness";
import HighfieldTrainings from "./Pages/trainings/HighfieldTrainings";
import HACCP_Levels from "./Pages/trainings/HACCP_Levels";
import PECB_Trainings from "./Pages/trainings/PECB_Trainings";
import ISO_Lead_Auditor_Trainings from "./Pages/trainings/ISO_Lead_Auditor_Trainings";
// import ISO9001_Details from "./Pages/trainings/ISO9001_Details";
// import ISO14001_Details from "./Pages/trainings/ISO14001_Details";
// import ISO45001_Details from "./Pages/trainings/ISO45001_Details";
// import ISO27001_Details from "./Pages/trainings/ISO27001_Details";
import Corporate_Trainings from "./Pages/trainings/Corporate_Trainings";
import Blog_Resources from "./Pages/resources/Blog_Resources";
import Downloads from "./Pages/resources/Downloads";
import FAQs from "./Pages/resources/FAQs";
import ISO9001_Details from "./Pages/trainings/Services Detail screen/ISO9001_Details";
import ISO14001_Details from "./Pages/trainings/Services Detail screen/ISO14001_Details";
import ISO45001_Details from "./Pages/trainings/Services Detail screen/ISO45001_Details";
import ISO27001_Details from "./Pages/trainings/Services Detail screen/ISO27001_Details";
import ISO13485_Details from "./Pages/trainings/ISO13485_Details";
import ISO17025_Details from "./Pages/trainings/ISO17025_Details";
import ISO22000_Details from "./Pages/trainings/ISO22000_Details";
import BRCGS_Details from "./Pages/trainings/BRCGS_Details";
import ISO50001_Details from "./Pages/trainings/ISO50001_Details";
import HACCP_Details from "./Pages/trainings/HACCP_Details";
import GMP_Details from "./Pages/trainings/GMP_Details";
import GlobalGAP_Details from "./Pages/trainings/GlobalGAP_Details";
import SQF_Details from "./Pages/trainings/SQF_Details";
import USFDA_Details from "./Pages/trainings/USFDA_Details";
import SFDA_Details from "./Pages/trainings/SFDA_Details";
import IFS_Details from "./Pages/trainings/IFS_Details";
import CFIA_Details from "./Pages/trainings/CFIA_Details";
import EcoVadis_Support from "./Pages/trainings/EcoVadis_Support";
import Carbon_GHG_Management from "./Pages/trainings/Carbon_GHG_Management";
import SEDEX_SEMETA_Details from "./Pages/trainings/SEDEX_SEMETA_Details";
import AMFORI_BSCI_Details from "./Pages/trainings/AMFORI_BSCI_Details";
import HIGG_Index_Details from "./Pages/trainings/HIGG_Index_Details";
import WRAP_Certification_Details from "./Pages/trainings/WRAP_Certification_Details";
import GreenBuilding_Certification_Details from "./Pages/trainings/GreenBuilding_Certification_Details";
import ISCC_Certification_Details from "./Pages/trainings/ISCC_Certification_Details";
import GSTC_Certification_Details from "./Pages/trainings/GSTC_Certification_Details";
import CDP_Certification_Details from "./Pages/trainings/CDP_Certification_Details";
import InternalAudits_Details from "./Pages/trainings/InternalAudits_Details";
import GapAnalysis_Details from "./Pages/trainings/GapAnalysis_Details";
import DocumentationDevelopment_Details from "./Pages/trainings/DocumentationDevelopment_Details";
import ISO20000_Details from "./Pages/trainings/Services Detail screen/ISO20000_Details";
import ISO27001_2022_Details from "./Pages/trainings/Services Detail screen/ISO27001_2022_Details";
import ISO27005_Details from "./Pages/trainings/Services Detail screen/ISO27005_Details";
import ISO27701_Details from "./Pages/trainings/Services Detail screen/ISO27701_Details";
import ISO27017_Details from "./Pages/trainings/Services Detail screen/ISO27017_Details";
import ISO27018_Details from "./Pages/trainings/Services Detail screen/ISO27018_Details";
import ISO22301_Details from "./Pages/trainings/Services Detail screen/ISO22301_Details";
import ISO42000_Details from "./Pages/trainings/Services Detail screen/ISO42000_Details";
import ISO41001_Details from "./Pages/trainings/Services Detail screen/ISO41001_Details";
import ISO55000_Details from "./Pages/trainings/Services Detail screen/ISO55000_Details";
import ISO27031_Details from "./Pages/trainings/Services Detail screen/ISO27031_Details";
import ISO31000_Details from "./Pages/trainings/Services Detail screen/ISO31000_Details";
import ITRiskAssessment_Details from "./Pages/trainings/Services Detail screen/ITRiskAssessment_Details";
import SOCType1_Details from "./Pages/trainings/Services Detail screen/SOCType1_Details";
import SOCType2_Details from "./Pages/trainings/Services Detail screen/SOCType2_Details";
import SOCType3_Details from "./Pages/trainings/Services Detail screen/SOCType3_Details";
import ISO17020_Details from "./Pages/trainings/Services Detail screen/ISO17020_Details";
import ThirdPartySupplierSecurity_Details from "./Pages/trainings/Services Detail screen/ThirdPartySupplierSecurity_Details";
import ISO17021CertificationBodies_Details from "./Pages/trainings/Services Detail screen/ISO17021CertificationBodies_Details";
import ISO17025Certification_Details from "./Pages/trainings/Services Detail screen/ISO17025Certification_Details";
import ISO17065CertificationBodies_Details from "./Pages/trainings/Services Detail screen/ISO17065CertificationBodies_Details";
import CareersAtMBASolutions from "./Pages/Careers/CareersAtMBASolutions";

function App() {
  const [showScrollTop, setShowScrollTop] = useState(false);
  const { specificBlogId } = useParams();

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {}, [specificBlogId]);
  const [cookies] = useCookies(["clickedServiceId"]);

  const user = localStorage.getItem("token");
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);
  return (
    <>
      {showScrollTop && (
        <div
          className="fixed bottom-8  z-[1000] hover:shadow-lg text-white  hover:scale-100 right-8 cursor-pointer bg-orange-600 transition-all ease-out duration-300 p-2 hover:bg-purple-700 shadow-md "
          onClick={scrollToTop}
        >
          <BsChevronUp size={22} className="" />
        </div>
      )}
      <WhatsAppLogo />
      <Cookies />
      <Routes>
        <Route path="/" element={<MainHome />} />

        <Route path="/index.php" element={<MainHome />} />
        <Route path="*" element={<PageNotFound />} />
        <Route path="/our_team.php" element={<Team />} />
        {user && <Route exact path="/admindashboard" element={<Dashboard />} />}
        {user && (
          <Route
            path="/adminlogin"
            element={<Navigate replace to="/admindashboard" />}
          />
        )}
        {user && (
          <Route exact path="/updateblog" element={<AdminBlogUpdate />} />
        )}
        {!user && (
          <Route
            path="/updateblog"
            element={<Navigate replace to="/adminologin" />}
          />
        )}

        {!user && (
          <Route
            exact
            path="/admindashboard"
            element={<Navigate replace to="/adminlogin" />}
          />
        )}
        {user && <Route path="/updateteam" element={<UpdateTeam />} />}

        {!user && (
          <Route
            exact
            path="/updateteam"
            element={<Navigate replace to="/adminlogin" />}
          />
        )}
        {user && <Route path="/updateposting" element={<UpdatePosting />} />}

        {!user && (
          <Route
            exact
            path="/updateposting"
            element={<Navigate replace to="/adminlogin" />}
          />
        )}

        {!user && <Route exact path="/adminlogin" element={<Login />} />}

        <Route path="/jobs" element={<Jobs />} />
        <Route path="/paymentForm" element={<PaymentForm />} />
        <Route path="/toolkits" element={<Toolkits />} />
        <Route path="/toolkits/success" element={<Success />} />
        <Route path="/toolkits/cancel" element={<Cancel />} />
        <Route path="/:name" element={<ServicePage2 />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/home" element={<MainHome />} />
        <Route path="/training-registration" element={<RegisterForm />} />
        <Route path="/pecb/:itemName" element={<Pecb />} />
        <Route path="/fsc-certification" element={<FSCCertification />} />
        <Route path="/team" element={<Team />} />
        <Route path="/training" element={<Trainings />} />
        <Route path="/tracking" element={<Tracking />} />
        {/* <Route path="/blog" element={<Blog />} /> */}
        <Route path="/sustainability" element={<Sustainability />} />
        <Route path="/blog/:specificBlogId" element={<NewBlogPage />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/jobs" element={<Jobs />} />
        <Route path="/training-details" element={<TrainingDetails />} />
        <Route
          path={`/service/${cookies.clickedServiceId}`}
          element={<Auditing />}
        />
        <Route path="/Skill_Building" element={<SkillBuilding />} />
        <Route path="/Certifications" element={<Certification />} />
        <Route path="/updateclient" element={<UpdateClient />} />
        <Route path="/clientele" element={<Clientele />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/sustainability/environment" element={<Environment />} />
        <Route
          path="/maximize-sustainability"
          element={<SustainabilityManagment />}
        />
        <Route
          path="/environment/environmental-policy"
          element={<EnvironmentPolicy />}
        />
        <Route
          path="/environment/environmental-management"
          element={<EnvironmentManagment />}
        />
        <Route
          path="/environment/environmental-balance"
          element={<EnvironmentalBalance />}
        />
        <Route path="/environment/biodiversity" element={<Biodiversity />} />
        <Route path="/environment/climate-change" element={<ClimateChange />} />
        <Route
          path="/environment/resource-circularity"
          element={<ResourceCircularity />}
        />

        <Route
          path="/sustainability/social-Governance"
          element={<SocialGovernance />}
        />
        <Route
          path="/social-governance/human-labored-rights"
          element={<HumanLabouredRight />}
        />
        <Route
          path="/social-governance/diversity-inclusions"
          element={<Diversity />}
        />
        <Route
          path="/social-governance/relationship-society"
          element={<Relationshipwithsociety />}
        />
        <Route
          path="/social-governance/fulfillment-work-environment"
          element={<Fulfillmentwork />}
        />
        <Route
          path="/social-governance/occupational-health-safety"
          element={<OccupationalHealth />}
        />
        <Route
          path="/social-governance/supply-chain-management"
          element={<SupplyChain />}
        />
        <Route
          path="/social-governance/corporate-governance"
          element={<CorporateGovernance />}
        />
        <Route
          path="/social-governance/risk-management"
          element={<RiskManagement />}
        />
        <Route path="/social-governance/compliance" element={<Compilance />} />
        <Route
          path="/social-governance/intellectual-properties"
          element={<IntelectualProperty />}
        />
        <Route
          path="/social-governance/quality-assurance"
          element={<QualityAssurance />}
        />
        <Route
          path="/sustainability/it-technology"
          element={<ItTechnology />}
        />
        <Route
          path="/it-technology/environmental-energy-management"
          element={<EnergyManagement />}
        />
        <Route
          path="/it-technology/circular-economy-e-waste"
          element={<ItTechnology />}
        />
        <Route
          path="/it-technology/ethical-sourcing-social-responsibility"
          element={<EthicalSourcing />}
        />
        <Route
          path="/it-technology/sustainable-it-infrastructure"
          element={<SustainableIt />}
        />
        <Route
          path="/it-technology/cybersecurity-sustainable-it"
          element={<CyberSecurity />}
        />
        <Route
          path="/sustainability-management"
          element={<SustainabilityManagement />}
        />

        {/* new routes about us tabs */}
        <Route path="/company-introduction" element={<CompanyIntroduction />} />
        <Route path="/mission" element={<Mission />} />
        <Route path="/vision" element={<Vision />} />
        <Route
          path="/diversified-clientele"
          element={<DiversifiedClientele />}
        />

        {/* new services tabs routes */}
        <Route path="/iso-certifications" element={<ISOCertifications />} />
        <Route path="/fsc-certifications" element={<FSCCOCCertification />} />
        <Route
          path="/food-safety-certifications"
          element={<FoodSafetyCertification />}
        />
        <Route path="/halal-certifications" element={<HalalCertification />} />
        <Route path="/it-cyber-security" element={<ITCyberSecurity />} />
        <Route path="/sustainability-esg" element={<SustainabilityESG />} />
        <Route path="/audits-documentation" element={<AuditsDocumentation />} />
        <Route
          path="/accreditation-readiness"
          element={<AccreditationReadiness />}
        />

        {/* new routes trainings tabs */}
        <Route path="/highfield-training" element={<HighfieldTrainings />} />
        <Route path="/haccp-training" element={<HACCP_Levels />} />
        <Route path="/pecb-training" element={<PECB_Trainings />} />
        <Route
          path="/iso-lead-auditor-training"
          element={<ISO_Lead_Auditor_Trainings />}
        />
        <Route
          path="/iso-lead-auditor-training/iso-9001"
          element={<ISO9001_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/iso-14001"
          element={<ISO14001_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/iso-45001"
          element={<ISO45001_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/iso-27001"
          element={<ISO27001_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/iso-13485"
          element={<ISO13485_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/iso-17025"
          element={<ISO17025_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/iso-22000"
          element={<ISO22000_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/brcgs"
          element={<BRCGS_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/iso-50001"
          element={<ISO50001_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/haccp"
          element={<HACCP_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/gmp"
          element={<GMP_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/globalgap"
          element={<GlobalGAP_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/sqf"
          element={<SQF_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/usfda"
          element={<USFDA_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/sfda"
          element={<SFDA_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/ifs"
          element={<IFS_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/cfia"
          element={<CFIA_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/ecovadis-support"
          element={<EcoVadis_Support />}
        />
        <Route
          path="/iso-lead-auditor-training/carbon-ghg"
          element={<Carbon_GHG_Management />}
        />
        <Route
          path="/iso-lead-auditor-training/sedex-semeta"
          element={<SEDEX_SEMETA_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/amfori-bsci"
          element={<AMFORI_BSCI_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/higg-index"
          element={<HIGG_Index_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/wrap"
          element={<WRAP_Certification_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/green-building"
          element={<GreenBuilding_Certification_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/iscc"
          element={<ISCC_Certification_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/gstc"
          element={<GSTC_Certification_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/cdp"
          element={<CDP_Certification_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/internal-audits"
          element={<InternalAudits_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/gap-analysis"
          element={<GapAnalysis_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/documentation-development"
          element={<DocumentationDevelopment_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/iso-20000"
          element={<ISO20000_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/iso-27001-2022"
          element={<ISO27001_2022_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/iso-27005"
          element={<ISO27005_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/iso-27701"
          element={<ISO27701_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/iso-27017"
          element={<ISO27017_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/iso-27018"
          element={<ISO27018_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/iso-22301"
          element={<ISO22301_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/iso-42000"
          element={<ISO42000_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/iso-41001"
          element={<ISO41001_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/iso-55000"
          element={<ISO55000_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/iso-27031"
          element={<ISO27031_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/iso-31000"
          element={<ISO31000_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/it-risk-assessment"
          element={<ITRiskAssessment_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/third-party-supplier-security"
          element={<ThirdPartySupplierSecurity_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/soc-type-1"
          element={<SOCType1_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/soc-type-2"
          element={<SOCType2_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/soc-type-3"
          element={<SOCType3_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/iso-17020"
          element={<ISO17020_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/iso-17021"
          element={<ISO17021CertificationBodies_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/iso-17025TSCL"
          element={<ISO17025Certification_Details />}
        />
        <Route
          path="/iso-lead-auditor-training/iso-17065"
          element={<ISO17065CertificationBodies_Details />}
        />
        <Route path="/corporate-training" element={<Corporate_Trainings />} />

        {/* new routes resources tabs */}
        <Route path="/blog" element={<Blog_Resources />} />
        <Route path="/downloads" element={<Downloads />} />
        <Route path="/faq" element={<FAQs />} />
        <Route path="/careers" element={<CareersAtMBASolutions />} />
      </Routes>
    </>
  );
}

export default App;
